import { render, staticRenderFns } from "./PhoneConfirmed.vue?vue&type=template&id=e33b5f0a"
import script from "./PhoneConfirmed.vue?vue&type=script&lang=ts"
export * from "./PhoneConfirmed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports